import { PayloadAction } from 'interfaces/action'
import { createPayloadAction } from 'helpers/actionsHelpers'
import { EventsMap, EventCategory } from 'components/features/beacon/types'

export const SEND_EVENT = 'SEND_EVENT' as const
export type SendEvent<TCategory extends EventCategory> = PayloadAction<typeof SEND_EVENT, { event: EventsMap[TCategory], category: TCategory }>

export const sendEventActionCreator = <TCategory extends EventCategory>(category: TCategory, event: EventsMap[TCategory]): SendEvent<TCategory> =>
  createPayloadAction(SEND_EVENT, { event, category })

type Action =
  | SendEvent<EventCategory>

export default Action
